import React from 'react';
import ReactSelect from 'react-select';
import PropTypes from 'prop-types';
import Label from './Label';
import Error from './Error';
import { getTranslation } from '../Text';
import { ALTO, WHITE, LOCHMARA, DOVE_GRAY } from '../../styles';
import { StyleSheet, css } from 'aphrodite/no-important';

const selectStyles = {
  control: (provided, state) => ({
    ...provided,
    width: '100%',
    border: `1px solid ${ALTO}`,
    appearance: 'none',
    boxSizing: 'border-box',
    backgroundColor: WHITE,
    height: 36,
    lineHeight: 1.25,
    fontSize: 'inherit',
    outline: 'none',
    borderRadius: 2,
    ':hover': {
      border: `1px solid ${ALTO}`,
    },
    ...(state.isFocused
      ? {
          border: `1px solid ${ALTO}`,
          boxShadow: 0,
        }
      : {}),
    ...(state.menuIsOpen
      ? {
          borderRadius: '2px 2px 0 0',
          border: `1px solid ${ALTO}`,
        }
      : {}),
    ...(state.isDisabled
      ? {
          opacity: 0.5,
        }
      : {}),
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    color: ALTO,
    transform: 'rotate(0)',
    transition: 'transform .3s',
    ...(state.menuIsOpen
      ? {
          transform: 'rotate(180deg)',
        }
      : {}),
  }),
  indicatorSeparator: (provided, state) => {
    return (
      state.selectProps.isClearable &&
      state.hasValue &&
      !state.isDisabled && {
        ...provided,
      }
    );
  },
  singleValue: (provided) => ({
    ...provided,
    color: DOVE_GRAY,
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '8px 11px',
    height: '100%',
    color: DOVE_GRAY,
  }),
  menu: (provided) => ({
    ...provided,
    marginTop: 0,
    borderRadius: '0 0 2px 2px',
    border: `1px solid ${ALTO}`,
    borderTopWidth: 0,
  }),
  option: (provided, state) => ({
    ...provided,
    color: DOVE_GRAY,
    backgroundColor: 'transparent!important',
    ...(state.isDisabled
      ? {
          opacity: 0.5,
        }
      : {}),
    ...(state.isFocused && !state.isDisabled
      ? {
          color: LOCHMARA,
          filter: 'brightness(120%)',
          backgroundColor: 'transparent!important',
        }
      : {}),
    ...(state.isSelected && !state.isDisabled
      ? {
          color: LOCHMARA,
          backgroundColor: 'transparent!important',
        }
      : {}),
  }),
  input: (provided) => ({
    ...provided,
    padding: 0,
  }),
};

const s = StyleSheet.create({
  root: {
    display: 'block',
    width: '100%',
    marginBottom: 12,
  },
});

const Select = ({
  label,
  options,
  value,
  error,
  isColorSelect,
  onChange,
  disabled,
  __containerClass,
  ...props
}) => {
  return (
    <label className={css(s.root, __containerClass && __containerClass)}>
      {!!label && <Label messageId={label} />}
      <ReactSelect
        placeholder=""
        styles={selectStyles}
        isDisabled={disabled}
        onChange={(e) => onChange({ value: e ? e.value : '' })}
        value={
          isColorSelect
            ? value
            : options.find((option) => option.value === value)
        }
        options={options.map((option) => ({
          value: option.value,
          label: getTranslation(option.label),
          isDisabled: option.disabled && option.value !== value,
        }))}
        {...props}
      />
      {!!error && <Error messageId={error} />}
    </label>
  );
};

Select.propTypes = {
  label: PropTypes.string,
  __containerClass: PropTypes.object,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  isSearchable: PropTypes.bool,
  isColorSelect: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  options: PropTypes.array,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
  ]),
};

Select.defaultProps = {
  isSearchable: false,
};

export default Select;
